const { CATEGORY, SUB_CATEGORY, MINOR_CATEGORY } = require('./FormConstants')
const recordTypeCustomer = {
  non_prod_id: 'recordType',
  prod_id: 'recordType',
  value: '012D0000000BSKJ',
}
const recordTypeFranchise = {
  non_prod_id: 'recordType',
  prod_id: 'recordType',
  // Non-prod-value below
  // value: '012TA000001zWK9',
  // Prod-value below
  value: '012Q4000003YfyH',
}
const recordTypeOnline = {
  non_prod_id: 'recordType',
  prod_id: 'recordType',
  value: '0123z000000kvOZ',
}

const businessAreaFieldIds = {
  non_prod_id: '00ND0000004zbjZ',
  prod_id: '00ND0000004zbjZ',
}

const businessAreaMorrisons = [
  {
    caption: 'Business Area',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: businessAreaFieldIds['non_prod_id'],
    prod_id: businessAreaFieldIds['prod_id'],
    non_prod_value: 'Morrisons',
    prod_value: 'Morrisons',
  },
]

const businessAreaOnline = [
  {
    caption: 'Business Area',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: businessAreaFieldIds['non_prod_id'],
    prod_id: businessAreaFieldIds['prod_id'],
    non_prod_value: 'Online',
    prod_value: 'Online',
  },
]

const businessAreaMore = [
  {
    caption: 'Business Area',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: businessAreaFieldIds['non_prod_id'],
    prod_id: businessAreaFieldIds['prod_id'],
    non_prod_value: 'Morrisons More',
    prod_value: 'Morrisons More',
  },
]

const genericFormsValues = (
  subject,
  caseType,
  caseCategory,
  caseReason,
  detailedReason,
  recordType
) => [
  {
    non_prod_id: 'subject',
    prod_id: 'subject',
    value: subject,
  },
  {
    caption: 'Case Type',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: '00ND0000004zbjY',
    prod_id: '00ND0000004zbjY',
    value: caseType,
  },
  {
    caption: 'Case Category',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: '00ND00000050NtJ',
    prod_id: '00ND00000050NtJ',
    value: caseCategory,
  },
  {
    caption: 'Case Reason',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: '00ND00000050NtL',
    prod_id: '00ND00000050NtL',
    value: caseReason,
  },
  {
    caption: 'Case Detailed Reason',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: '00ND00000053hva',
    prod_id: '00ND00000053hva',
    value: detailedReason,
  },
  {
    caption: 'Record Type',
    description: 'Hidden field to hold Salesforce required value',
    non_prod_id: 'recordType',
    prod_id: 'recordType',
    value: recordType,
  },
]

const genericFormsDefaults = () => [...businessAreaMorrisons]
const genericFormsMorrisonsDaily = () => [...businessAreaMorrisons]
const genericFormsMore = () => [...businessAreaMore]
const onlineFormsDefaults = () => [...businessAreaOnline]
// const genericFormsDynamicRecords = () => [...businessAreaMorrisons]

const scanShopFormsDefaults = () => [...businessAreaMorrisons]

const data = {
  services: [
    'store',
    'product',
    'online-shopping-experience',
    'morrisons-more',
    'food-to-order',
    'morrisons-daily',
  ],
  steps: [
    {
      value: 'Online Shopping Experience',
      salesForceType: CATEGORY,
      text: 'Online Shopping Experience',
      searchCategory: 'Online Shopping Experience',
      searchSubCategory: null,
      nodes: [
        {
          value: 'Online Enquiries',
          salesForceType: SUB_CATEGORY,
          text: 'Online Enquiries',
          nodes: [
            {
              value: 'I received an out of date product in my order',
              salesForceType: SUB_CATEGORY,
              text: 'I received an out of date product in my order',
              form: {
                name: 'online-shopping-product-complaint-form-date',
                fields: [...genericFormsValues(), ...onlineFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Online - Product Out of Date',
                    caseType: 'Complaint',
                    caseCategory: 'Product',
                    caseReason: 'Product Dates',
                    detailedReason: '',
                    recordType: recordTypeOnline.value,
                  },
                ],
              },
            },
            {
              value: "I have a substitute I don't want",
              salesForceType: SUB_CATEGORY,
              text: "I have a substitute I don't want",
              form: {
                name: 'online-shopping-product-complaint-form-substitute',
                fields: [...genericFormsValues(), ...onlineFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Online - Substitutions',
                    caseType: 'Complaint',
                    caseCategory: 'Order',
                    caseReason: 'Substitutions',
                    detailedReason: '',
                    recordType: recordTypeOnline.value,
                  },
                ],
              },
            },
            {
              value:
                "I'm missing an item from my delivery, and it has been charged for on my receipt",
              salesForceType: SUB_CATEGORY,
              text:
                "I'm missing an item from my delivery, and it has been charged for on my receipt",
              form: {
                name: 'online-shopping-product-complaint-form-missing-item',
                fields: [...genericFormsValues(), ...onlineFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Online - Missing Item',
                    caseType: 'Complaint',
                    caseCategory: 'Order',
                    caseReason: 'Missing Products',
                    detailedReason: '',
                    recordType: recordTypeOnline.value,
                  },
                ],
              },
            },
            {
              value: 'My delivery arrived too early or too late',
              salesForceType: SUB_CATEGORY,
              text: 'My delivery arrived too early or too late',
              form: {
                name: 'enquiry-with-orderid-and-date',
                fields: [...genericFormsValues(), ...onlineFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Online - Delivery',
                    caseType: 'Complaint',
                    caseCategory: 'Delivery',
                    caseReason: 'Late Delivery',
                    detailedReason: '',
                    recordType: recordTypeOnline.value,
                  },
                ],
              },
            },
            {
              value: 'My payment is not being accepted',
              salesForceType: SUB_CATEGORY,
              text: 'My payment is not being accepted',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...onlineFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Online - Checkout Issues',
                    caseType: 'Enquiry',
                    caseCategory: 'Customer Support (E)',
                    caseReason: 'Help customer place an order (E)',
                    detailedReason: '',
                    recordType: recordTypeOnline.value,
                  },
                ],
              },
            },
            {
              value: 'I need help with my voucher code',
              salesForceType: SUB_CATEGORY,
              text: 'I need help with my voucher code',
              form: {
                name: 'enquiry-form-with-bbd',
                fields: [...genericFormsValues(), ...onlineFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Online - Voucher Code',
                    caseType: 'Complaint',
                    caseCategory: 'Payments',
                    caseReason: 'Vouchers / Discount not being Applied',
                    detailedReason: '',
                    recordType: recordTypeOnline.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Products',
      salesForceType: CATEGORY,
      text: 'Products',
      searchCategory: 'Products',
      searchSubCategory: null,
      nodes: [
        {
          value: 'I have a complaint about a product',
          salesForceType: SUB_CATEGORY,
          text: 'I have a complaint about a product',
          nodes: [
            {
              value: 'A product I purchased in store has made me ill',
              salesForceType: SUB_CATEGORY,
              text: 'A product I purchased in store has made me ill',
              form: {
                name: 'product-illness-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'A product I purchased in store has made me ill',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Illness or Injury',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'A product I purchased in store has made me ill',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Illness',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'A product I purchased in store has made me ill',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Illness',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'A product I purchased in store has caused me an injury',
              salesForceType: MINOR_CATEGORY,
              text: 'A product I purchased in store has caused me an injury',
              form: {
                name: 'product-complaint-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'A product I purchased in store has caused me an injury',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Injury From a Product',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'A product I purchased in store has caused me an injury',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Injury From a Product',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'A product I purchased in store has caused me an injury',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Injury From a Product',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'A product I purchased in store contains a foreign body',
              salesForceType: MINOR_CATEGORY,
              text: 'A product I purchased in store contains a foreign body',
              form: {
                name: 'foreign-body-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'A product I purchased in store contains a foreign body',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Foreign Bodies',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'A product I purchased in store contains a foreign body',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Foreign Bodies',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'A product I purchased in store contains a foreign body',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Foreign Bodies',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I have suffered an allergic reaction from a product I purchased In Store',
              salesForceType: MINOR_CATEGORY,
              text:
                'I have suffered an allergic reaction from a product I purchased In Store',
              form: {
                name: 'alleged-allergen-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I have suffered an allergic reaction from a product I purchased In Store',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Alleged Allergens',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I have suffered an allergic reaction from a product I purchased In Store',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Alleged Allergens',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I have suffered an allergic reaction from a product I purchased In Store',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Alleged Allergens',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'A product I purchased In store is out of Date',
              salesForceType: MINOR_CATEGORY,
              text: 'A product I purchased In store is out of Date',
              form: {
                name: 'out-of-date-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'A product I purchased In store is out of Date',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Product Dates',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'A product I purchased In store is out of Date',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Product Sold Out Of Date',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'A product I purchased In store is out of Date',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Product Sold Out Of Date',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'A product I purchased in store is Faulty / Defective',
              salesForceType: MINOR_CATEGORY,
              text: 'A product I purchased in store is Faulty / Defective',
              form: {
                name: 'product-complaint-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'A product I purchased in store is Faulty / Defective',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Product Quality',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'A product I purchased in store is Faulty / Defective',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Customer Unhappy with Quality/Taste/Value etc',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'A product I purchased in store is Faulty / Defective',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Customer Unhappy with Quality/Taste/Value etc',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'A product I purchased in store is of poor quality',
              salesForceType: MINOR_CATEGORY,
              text: 'A product I purchased in store is of poor quality',
              form: {
                name: 'product-complaint-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'A product I purchased in store is of poor quality',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Product Quality',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'A product I purchased in store is of poor quality',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Customer Unhappy with Quality/Taste/Value etc',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'A product I purchased in store is of poor quality',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Customer Unhappy with Quality/Taste/Value etc',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'The product I purchased was packaged/labelled incorrectly',
              salesForceType: MINOR_CATEGORY,
              text: 'The product I purchased was packaged/labelled incorrectly',
              form: {
                name: 'product-complaint-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'The product I purchased was packaged/labelled incorrectly',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Product',
                    caseReason: 'Packaging/Labelling Issues',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'The product I purchased was packaged/labelled incorrectly',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Product',
                    caseReason: 'Packaging/Labelling Issues',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'The product I purchased was packaged/labelled incorrectly',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Product',
                    caseReason: 'Packaging/Labelling Issues',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'I have an enquiry about a product',
          salesForceType: SUB_CATEGORY,
          text: 'I have an enquiry about a product',
          nodes: [
            {
              value:
                'I would like more information on Allergens in in store purchased products',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like more information on Allergens in in store purchased products',
              form: {
                name: 'product-enquiry-with-barcode',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like more information on Allergens in in store purchased products',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Allergy/ingredients information (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like more information on Allergens in in store purchased products',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Allergy/ingredients information (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like more information on Allergens in in store purchased products',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Allergy/ingredients information (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like more information on the nutritional information of in store purchased products',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like more information on the nutritional information of in store purchased products',
              form: {
                name: 'product-enquiry-with-barcode',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like more information on the nutritional information of in store purchased products',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability/ Do we stock (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like more information on the nutritional information of in store purchased products',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like more information on the nutritional information of in store purchased products',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like more information on the ingredients information on an in store purchased products',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like more information on the ingredients information on an in store purchased products',
              form: {
                name: 'product-enquiry-with-barcode',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like more information on the ingredients information on an in store purchased products',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Allergy/ingredients information (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like more information on the ingredients information on an in store purchased products',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Allergy/ingredients information (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like more information on the ingredients information on an in store purchased products',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Allergy/ingredients information (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like some more information on the pricing of your in store items',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like some more information on the pricing of your in store items',
              form: {
                name: 'enquiry-with-store-and-online-redirect',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like some more information on the pricing of your in store items',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Price (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like some more information on the pricing of your in store items',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like some more information on the pricing of your in store items',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like to check the stock levels of an in store product',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like to check the stock levels of an in store product',
              form: {
                name: 'enquiry-with-store-and-online-redirect',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to check the stock levels of an in store product',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability/ Do we stock (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like to check the stock levels of an in store product',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like to check the stock levels of an in store product',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Can I Reserve a Product In store',
              salesForceType: MINOR_CATEGORY,
              text: 'Can I Reserve a Product In store',
              form: {
                name: 'enquiry-with-store-and-online-redirect',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Can I Reserve a Product In store',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability/ Do we stock (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Can I Reserve a Product In store',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Can I Reserve a Product In store',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'Can I find out when a product will be back available in store',
              salesForceType: MINOR_CATEGORY,
              text:
                'Can I find out when a product will be back available in store',
              form: {
                name: 'enquiry-with-store-and-online-redirect',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'Can I find out when a product will be back available in store',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability/ Do we stock (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'Can I find out when a product will be back available in store',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'Can I find out when a product will be back available in store',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like to request a new product to be stocked in store',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like to request a new product to be stocked in store',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to request a new product to be stocked in store',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'New product request (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like to request a new product to be stocked in store',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like to request a new product to be stocked in store',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Morrisons More',
      salesForceType: CATEGORY,
      text: 'Morrisons More',
      searchCategory: 'Morrisons More',
      searchSubCategory: null,
      nodes: [
        {
          value: 'Morrisons More Account',
          salesForceType: SUB_CATEGORY,
          text: 'Morrisons More Account',
          nodes: [
            {
              hideForm: true,
              hideRelated: true,
              morePartnersInfo: true,
              value: 'More Partners',
              salesForceType: MINOR_CATEGORY,
              text: 'More Partners',
              form: {
                name: 'more-partners-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons More',
                    subject: 'More Partners',
                    caseType: 'Complaint - More',
                    caseCategory: 'More Partners',
                    caseReason: '',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I am an existing customer, do I need a new username and password?',
              salesForceType: MINOR_CATEGORY,
              text:
                'I am an existing customer, do I need a new username and password?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I am an existing customer, do I need a new username and password?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I am an existing customer, do I need a new username and password?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I am an existing customer, do I need a new username and password?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I suspect someone has access to my Morrisons More account',
              salesForceType: MINOR_CATEGORY,
              text: 'I suspect someone has access to my Morrisons More account',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I suspect someone has access to my Morrisons More account',
                    caseType: 'Complaint - More',
                    caseCategory: 'Customer Account',
                    caseReason: 'Suspected Fraud',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I suspect someone has access to my Morrisons More account',
                    caseType: 'Complaint - More',
                    caseCategory: 'Customer Account',
                    caseReason: 'Suspected Fraud',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I suspect someone has access to my Morrisons More account',
                    caseType: 'Complaint - More',
                    caseCategory: 'Customer Account',
                    caseReason: 'Suspected Fraud',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Morrisons More Card',
          salesForceType: SUB_CATEGORY,
          text: 'Morrisons More Card',
          nodes: [
            {
              value: 'When will I receive my new Morrisons More card & how?',
              salesForceType: MINOR_CATEGORY,
              text: 'When will I receive my new Morrisons More card & how?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'When will I receive my new Morrisons More card & how?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Card (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'When will I receive my new Morrisons More card & how?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Card (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'When will I receive my new Morrisons More card & how?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Card (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Why have I not received my new Morrisons More Card?',
              salesForceType: MINOR_CATEGORY,
              text: 'Why have I not received my new Morrisons More Card?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'Why have I not received my new Morrisons More Card?',
                    caseType: 'Complaint - More',
                    caseCategory: 'Customer Account',
                    caseReason: 'Card',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'Why have I not received my new Morrisons More Card?',
                    caseType: 'Complaint - More',
                    caseCategory: 'Customer Account',
                    caseReason: 'Card',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'Why have I not received my new Morrisons More Card?',
                    caseType: 'Complaint - More',
                    caseCategory: 'Customer Account',
                    caseReason: 'Card',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'What should I do if my card is lost / stolen or damaged?',
              salesForceType: MINOR_CATEGORY,
              text: 'What should I do if my card is lost / stolen or damaged?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'What should I do if my card is lost / stolen or damaged?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Card (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'What should I do if my card is lost / stolen or damaged?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Card (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'What should I do if my card is lost / stolen or damaged?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Card (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Morrisons More Points and Promotions',
          salesForceType: SUB_CATEGORY,
          text: 'Morrisons More Points and Promotions',
          nodes: [
            {
              value: 'I have not received the points for my Fuel',
              salesForceType: MINOR_CATEGORY,
              text: 'I have not received the points for my Fuel',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I have not received the points for my Fuel',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'More Points',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'I have not received the points for my Fuel',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'More Points',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'I have not received the points for my Fuel',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'More Points',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'I have not received points on a promotion',
              salesForceType: MINOR_CATEGORY,
              text: 'I have not received points on a promotion',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I have not received points on a promotion',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'Personalised Rewards & Points Offers',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'I have not received points on a promotion',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'Personalised Rewards & Points Offers',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'I have not received points on a promotion',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'Personalised Rewards & Points Offers',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },

            {
              value: 'How do I receive promotions?',
              salesForceType: MINOR_CATEGORY,
              text: 'How do I receive promotions?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'How do I receive promotions?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'How do I receive promotions?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'How do I receive promotions?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'How do I activate promotions?',
              salesForceType: MINOR_CATEGORY,
              text: 'How do I activate promotions?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'How do I activate promotions?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'How do I activate promotions?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'How do I activate promotions?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Morrisons More Clubs',
          salesForceType: SUB_CATEGORY,
          text: 'Morrisons More Clubs',
          nodes: [
            {
              value:
                'What if I do not have a NHS, School or Student Email Address?',
              salesForceType: MINOR_CATEGORY,
              text:
                'What if I do not have a NHS, School or Student Email Address?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'What if I do not have a NHS, School or Student Email Address?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'What if I do not have a NHS, School or Student Email Address?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'What if I do not have a NHS, School or Student Email Address?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'Promotions query (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I have not received the activation email to complete my sign up for my Club?',
              salesForceType: MINOR_CATEGORY,
              text:
                'I have not received the activation email to complete my sign up for my Club?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I have not received the activation email to complete my sign up for my Club?',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'Clubs & Digital Christmas Savers',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I have not received the activation email to complete my sign up for my Club?',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'Clubs & Digital Christmas Savers',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I have not received the activation email to complete my sign up for my Club?',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'Clubs & Digital Christmas Savers',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Morrisons More Technical Issues',
          salesForceType: SUB_CATEGORY,
          text: 'Morrisons More Technical Issues',
          nodes: [
            {
              value: 'I am having issues logging into the Morrisons More App',
              salesForceType: MINOR_CATEGORY,
              text: 'I am having issues logging into the Morrisons More App',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I am having issues logging into the Morrisons More App',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I am having issues logging into the Morrisons More App',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I am having issues logging into the Morrisons More App',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I am unable to log into my Morrisons More online account on the website',
              salesForceType: MINOR_CATEGORY,
              text:
                'I am unable to log into my Morrisons More online account on the website',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I am unable to log into my Morrisons More online account on the website',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I am unable to log into my Morrisons More online account on the website',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I am unable to log into my Morrisons More online account on the website',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'My Morrisons More Card Number is different on the App / My Online Account',
              salesForceType: MINOR_CATEGORY,
              text:
                'My Morrisons More Card Number is different on the App / My Online Account',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'My Morrisons More Card Number is different on the App / My Online Account',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'My Morrisons More Card Number is different on the App / My Online Account',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'My Morrisons More Card Number is different on the App / My Online Account',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I am not seeing any offers or promotions on the Morrisons More app',
              salesForceType: MINOR_CATEGORY,
              text:
                'I am not seeing any offers or promotions on the Morrisons More app',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I am not seeing any offers or promotions on the Morrisons More app',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I am not seeing any offers or promotions on the Morrisons More app',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I am not seeing any offers or promotions on the Morrisons More app',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'The Morrisons More app is not working on my iPhone',
              salesForceType: MINOR_CATEGORY,
              text: 'The Morrisons More app is not working on my iPhone',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'The Morrisons More app is not working on my iPhone',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'The Morrisons More app is not working on my iPhone',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'The Morrisons More app is not working on my iPhone',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'The Morrisons More app is not working on my Android phone',
              salesForceType: MINOR_CATEGORY,
              text: 'The Morrisons More app is not working on my Android phone',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'The Morrisons More app is not working on my Android phone',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'The Morrisons More app is not working on my Android phone',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'The Morrisons More app is not working on my Android phone',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Customer Account (E)',
                    caseReason: 'Account /Technical Enquiries (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'My Points Boosters Promotions',
          salesForceType: SUB_CATEGORY,
          text: 'My Points Boosters Promotions',
          nodes: [
            {
              value: 'My Points Boosters Enquiry',
              salesForceType: MINOR_CATEGORY,
              text: 'My Points Boosters Enquiry',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'My Points Boosters Enquiry',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'My Points Boosters Promotions (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'My Points Boosters Enquiry',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'My Points Boosters Promotions (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'My Points Boosters Enquiry',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'My Points Boosters Promotions (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Morrisons More Collector - App',
          salesForceType: SUB_CATEGORY,
          text: 'Morrisons More Collector - App',
          nodes: [
            {
              value: 'Weekly Spend Collector Promotion Enquiry',
              salesForceType: MINOR_CATEGORY,
              text: 'Weekly Spend Collector Promotion Enquiry',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Weekly Spend Collector Promotion Enquiry',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Weekly Spend Collector Promotion Enquiry',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Weekly Spend Collector Promotion Enquiry',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Why do I have to click the ‘Activate Now’ button?',
              salesForceType: MINOR_CATEGORY,
              text: 'Why do I have to click the ‘Activate Now’ button?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                "I didn't click ‘Activate Now’ until Week 2 will my Week 1 shops still count?",
              salesForceType: MINOR_CATEGORY,
              text:
                "I didn't click ‘Activate Now’ until Week 2 will my Week 1 shops still count?",
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'When do I receive my Collector Bonus Points?',
              salesForceType: MINOR_CATEGORY,
              text: 'When do I receive my Collector Bonus Points?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'How will I receive my More Points Bonus?',
              salesForceType: MINOR_CATEGORY,
              text: 'How will I receive my More Points Bonus?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
              salesForceType: MINOR_CATEGORY,
              text:
                "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      "I didn't click 'Activate Now' until Week 2 will my Week 1 shops still count?",
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I shop both in store and online - will my weekly total include both?',
              salesForceType: MINOR_CATEGORY,
              text:
                'I shop both in store and online - will my weekly total include both?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I shop both in store and online - will my weekly total include both?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I shop both in store and online - will my weekly total include both?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I shop both in store and online - will my weekly total include both?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'How will I receive my More Points Bonus?',
              salesForceType: MINOR_CATEGORY,
              text: 'How will I receive my More Points Bonus?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'How will I receive my More Points Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Can I change how I want to receive my Bonus?',
              salesForceType: MINOR_CATEGORY,
              text: 'Can I change how I want to receive my Bonus?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Can I change how I want to receive my Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Can I change how I want to receive my Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Can I change how I want to receive my Bonus?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'What are the exclusions from my weekly spend?',
              salesForceType: MINOR_CATEGORY,
              text: 'What are the exclusions from my weekly spend?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'What are the exclusions from my weekly spend?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'What are the exclusions from my weekly spend?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'What are the exclusions from my weekly spend?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Where can I track my weekly progress?',
              salesForceType: MINOR_CATEGORY,
              text: 'Where can I track my weekly progress?',
              form: {
                name: 'general-enquiry-form',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Where can I track my weekly progress?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Where can I track my weekly progress?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Where can I track my weekly progress?',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason:
                      'Collector Schemes (inc Xmas/Easter/Summer) (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Free Pyrex with More Card Stamps',
          salesForceType: SUB_CATEGORY,
          text: 'Free Pyrex with More Card Stamps',
          nodes: [
            {
              value: 'How can I get the More Card Stamps I was entitled to?',
              salesForceType: MINOR_CATEGORY,
              text: 'How can I get the More Card Stamps I was entitled to?',
              form: {
                name: 'general-enquiry-form-with-receipt',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'More Stamps',
                    caseType: 'Complaint - More',
                    caseCategory: 'Promotions',
                    caseReason: 'More Stamps',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'What happens if I forgot to scan my Morrisons More Card?',
              salesForceType: MINOR_CATEGORY,
              text: 'What happens if I forgot to scan my Morrisons More Card?',
              form: {
                name: 'general-enquiry-form-with-receipt',
                fields: [...genericFormsValues(), ...genericFormsMore()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'More Stamps',
                    caseType: 'Enquiry - More',
                    caseCategory: 'Promotions (E)',
                    caseReason: 'More Stamps (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Petrol Stations',
      salesForceType: CATEGORY,
      text: 'Petrol Stations',
      searchCategory: 'Stores',
      searchSubCategory: 'Petrol Stations',
      nodes: [
        {
          value: 'Petrol Stations',
          salesForceType: SUB_CATEGORY,
          text: 'Petrol Stations',
          nodes: [
            {
              value: 'Petrol Pricing',
              salesForceType: MINOR_CATEGORY,
              text: 'Petrol Pricing',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Petrol Pricing',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Pricing (PFS)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Petrol Pricing',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Pricing (PFS)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Petrol Pricing',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Pricing (PFS)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Fuel Contamination',
              salesForceType: MINOR_CATEGORY,
              text: 'Fuel Contamination',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Fuel Contamination',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Petrol Filling Station',
                    caseReason: 'PFS Maintenance',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Fuel Contamination',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Petrol Filling Station',
                    caseReason: 'PFS Maintenance',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Fuel Contamination',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Petrol Filling Station',
                    caseReason: 'PFS Maintenance',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },

            {
              value: 'Petrol station cleanliness and equipment',
              salesForceType: MINOR_CATEGORY,
              text: 'Petrol station cleanliness and equipment',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Petrol station cleanliness and equipment',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Petrol Filling Station',
                    caseReason: 'PFS Maintenance',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Petrol station cleanliness and equipment',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Petrol Filling Station',
                    caseReason: 'PFS Maintenance',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Petrol station cleanliness and equipment',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Petrol Filling Station',
                    caseReason: 'PFS Maintenance',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Car Wash',
              salesForceType: MINOR_CATEGORY,
              text: 'Car Wash',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Car Wash',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Car Wash',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Car Wash',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Car Wash',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Car Wash',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Car Wash',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Pay at pump',
              salesForceType: MINOR_CATEGORY,
              text: 'Pay at pump',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Pay at pump',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Pay at Pump',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Pay at pump',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Pay at Pump',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Pay at pump',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Petrol Filling station (E)',
                    caseReason: 'Pay at Pump',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Cafe',
      salesForceType: CATEGORY,
      text: 'Cafe',
      searchCategory: 'Stores',
      searchSubCategory: 'Cafe',
      nodes: [
        {
          value: 'General',
          salesForceType: SUB_CATEGORY,
          text: 'General',
          nodes: [
            {
              value:
                'I want to give you feedback about the quality of the food',
              salesForceType: MINOR_CATEGORY,
              text: 'I want to give you feedback about the quality of the food',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to give you feedback about the quality of the food',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Cafe',
                    caseReason: 'Quality Of Food',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I want to give you feedback about the wait time in the cafe',
              salesForceType: MINOR_CATEGORY,
              text:
                'I want to give you feedback about the wait time in the cafe',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to give you feedback about the wait time in the cafe',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Cafe',
                    caseReason: 'Cafe Wait Times',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I was not able to order an item from the menu due to availability',
              salesForceType: MINOR_CATEGORY,
              text:
                'I was not able to order an item from the menu due to availability',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I was not able to order an item from the menu due to availability',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Cafe',
                    caseReason: 'Cafe Menu / Range',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I want to give you feedback about your cafe appearance and housekeeping',
              salesForceType: MINOR_CATEGORY,
              text:
                'I want to give you feedback about your cafe appearance and housekeeping',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to give you feedback about your cafe appearance and housekeeping',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Cafe',
                    caseReason: 'Cafe - Service',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'I want to give you feedback about your menu or range',
              salesForceType: MINOR_CATEGORY,
              text: 'I want to give you feedback about your menu or range',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to give you feedback about your menu or range',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Cafe',
                    caseReason: 'Cafe Menu / Range',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'I have feedback regarding service in Cafe',
              salesForceType: MINOR_CATEGORY,
              text: 'I have feedback regarding service in Cafe',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I have feedback regarding service in Cafe',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Cafe',
                    caseReason: 'Cafe - Service',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Pricing and Promotions',
      salesForceType: CATEGORY,
      text: 'Pricing and Promotions',
      searchCategory: 'Products',
      searchSubCategory: null,
      nodes: [
        {
          value: 'General',
          salesForceType: SUB_CATEGORY,
          text: 'General',
          nodes: [
            {
              value: 'Price increases',
              salesForceType: MINOR_CATEGORY,
              text: 'Price increases',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Price increases',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Pricing & Promotions',
                    caseReason:
                      'Pricing ( Standard Promotion not More Card Promotion )',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Price increases',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Pricing',
                    caseReason: 'Increase in Price',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Price increases',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Pricing',
                    caseReason: 'Increase in Price',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Promotional offers',
              salesForceType: MINOR_CATEGORY,
              text: 'Promotional offers',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Promotional offers',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Price (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Promotional offers',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Promotional offers',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: "I don't think I have been charged the right price",
              salesForceType: SUB_CATEGORY,
              text: "I don't think I have been charged the right price",
              form: {
                name: 'enquiry-with-store-more-info',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I dont think I have been charged the right price',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Pricing & Promotions',
                    caseReason:
                      'Pricing ( Standard Promotion not More Card Promotion )',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'I dont think I have been charged the right price',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Pricing',
                    caseReason: 'Pricing Error',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'I dont think I have been charged the right price',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Pricing',
                    caseReason: 'Pricing Error',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'I want to give you feedback on your marketing campaigns',
              salesForceType: MINOR_CATEGORY,
              text: 'I want to give you feedback on your marketing campaigns',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to give you feedback on your marketing campaigns',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Price (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I want to give you feedback on your marketing campaigns',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I want to give you feedback on your marketing campaigns',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I want to give you feedback on your TV/Newspaper Adverts or leaflets',
              salesForceType: MINOR_CATEGORY,
              text:
                'I want to give you feedback on your TV/Newspaper Adverts or leaflets',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to give you feedback on your TV/Newspaper Adverts or leaflets',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Price (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I want to give you feedback on your TV/Newspaper Adverts or leaflets',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I want to give you feedback on your TV/Newspaper Adverts or leaflets',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I want to tell you about a coupon (excluding Morrions More)',
              salesForceType: MINOR_CATEGORY,
              text:
                'I want to tell you about a coupon (excluding Morrions More)',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I want to tell you about a coupon (excluding Morrisons More)',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Price (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I want to tell you about a coupon (excluding Morrisons More)',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I want to tell you about a coupon (excluding Morrisons More)',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Feedback (E)',
                    caseReason: 'Feedback (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'garden-leisure',
      salesForceType: CATEGORY,
      text: 'Home Electricals',
      nodes: [
        {
          value: 'replacements',
          salesForceType: SUB_CATEGORY,
          text: 'Download instructions or request part for',
          nodes: [
            {
              value: 'Electrical Product',
              salesForceType: MINOR_CATEGORY,
              text: 'Electrical Product',
              form: {
                name: 'electrical-instructions-and-parts-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I have a enquiry about Replacement / Spare Part',
                    caseType: 'Enquiry (M)',
                    caseCategory: 'Replacement / Spare Parts',
                    caseReason: 'Electrical',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Car park',
      salesForceType: CATEGORY,
      text: 'Car park',
      searchCategory: 'Stores',
      searchSubCategory: 'Car parks',
      nodes: [
        {
          value: 'Car parking charges',
          salesForceType: SUB_CATEGORY,
          text: 'Car parking charges',
          nodes: [
            {
              value: 'I have a car parking charge',
              salesForceType: MINOR_CATEGORY,
              text: 'I have a car parking charge',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I have a car parking charge',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Car Parks',
                    caseReason: 'Parking Charges',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'car-park',
          salesForceType: SUB_CATEGORY,
          text: 'Car park',
          nodes: [
            {
              value: 'Disabled/Mother & Toddler parking',
              salesForceType: MINOR_CATEGORY,
              text: 'Disabled/Mother & Toddler parking',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Disabled/Mother & Toddler parking',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Car Parks (E)',
                    caseReason: 'Parking (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Car Park Cleanliness',
              salesForceType: MINOR_CATEGORY,
              text: 'Car Park Cleanliness',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Car Park Cleanliness',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Car Parks (E)',
                    caseReason: 'Parking (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like to give feedback regarding your Car Park Maintenance',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like to give feedback regarding your Car Park Maintenance',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to give feedback regarding your Car Park Maintenance',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Car Parks (E)',
                    caseReason: 'Parking (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Signage in our Car Park',
              salesForceType: MINOR_CATEGORY,
              text: 'Signage in our Car Park',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Signage in our Car Park',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Car Parks (E)',
                    caseReason: 'Parking (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Lack of Car Park Spaces',
              salesForceType: MINOR_CATEGORY,
              text: 'Lack of Car Park Spaces',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Lack of Car Park Spaces',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Car Parks (E)',
                    caseReason: 'Parking (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
            {
              value: 'Car Park Attendants',
              salesForceType: MINOR_CATEGORY,
              text: 'Car Park Attendants',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Car Park Attendants',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Car Parks (E)',
                    caseReason: 'Parking (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Store services and transport',
      salesForceType: CATEGORY,
      text: 'Store services and transport',
      searchCategory: 'Stores',
      searchSubCategory: 'Store services and transport',
      nodes: [
        {
          value: 'General',
          salesForceType: SUB_CATEGORY,
          text: 'General',
          nodes: [
            {
              value: 'Unhappy regarding  Morrisons Transport',
              salesForceType: MINOR_CATEGORY,
              text: 'Unhappy regarding  Morrisons Transport',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Unhappy regarding Morrisons Transport',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Concessions/3rd Party Issues',
                    caseReason: 'Unhappy with 3rd Party Promoters',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Unhappy regarding Morrisons Transport',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Transport',
                    caseReason: 'Unsafe / Irresponsible Parking',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Unhappy regarding Morrisons Transport',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Transport',
                    caseReason: 'Unsafe / Irresponsible Parking',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Coin Star',
              salesForceType: MINOR_CATEGORY,
              text: 'Complaint re Coin Star',
              form: {
                name: 'enquiry-just-stores',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Complaint re Coin Star',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Concessions/3rd Party Issues',
                    caseReason: 'Coinstar',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                ],
              },
            },

            {
              value: 'I have an enquiry about your 3rd party services',
              salesForceType: MINOR_CATEGORY,
              text: 'I have an enquiry about your 3rd party services',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I have an enquiry about your 3rd party services',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Concessions/3rd Party Issues (E)',
                    caseReason: 'None',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'I have an enquiry about your 3rd party services',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'In-Store Services (E)',
                    caseReason: 'None',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'I have an enquiry about your 3rd party services',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'In-Store Services (E)',
                    caseReason: 'None',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Other',
              salesForceType: MINOR_CATEGORY,
              text: 'Other',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'Other',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Concessions/3rd Party Issues',
                    caseReason: 'None',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'Other',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'In-Store Services (E)',
                    caseReason: 'None',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'Other',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'In-Store Services (E)',
                    caseReason: 'None',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Compliments',
      salesForceType: CATEGORY,
      text: 'Compliments',
      searchCategory: 'Stores',
      searchSubCategory: 'Compliments',
      nodes: [
        {
          value: 'colleagues',
          salesForceType: SUB_CATEGORY,
          text: 'Our colleagues',
          nodes: [
            {
              value: 'I would like to compliment one of your colleagues',
              salesForceType: MINOR_CATEGORY,
              text: 'I would like to compliment one of your colleagues',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to compliment one of your colleagues',
                    caseType: 'Compliment - Morrisons',
                    caseCategory: 'Compliment (store) (E)',
                    caseReason: 'Service (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like to compliment one of your colleagues',
                    caseType: 'Compliment - Franchise',
                    caseCategory: 'Compliment (E)',
                    caseReason: 'Compliment about Colleague Service (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like to compliment one of your colleagues',
                    caseType: 'Compliment - Morrisons Daily',
                    caseCategory: 'Compliment (E)',
                    caseReason: 'Compliment about Colleague Service (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'products',
          salesForceType: SUB_CATEGORY,
          text: 'Our products',
          nodes: [
            {
              value: 'I would like to compliment one of your products',
              salesForceType: MINOR_CATEGORY,
              text: 'I would like to compliment one of your products',
              form: {
                name: 'enquiry-with-store',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: 'I would like to compliment one of your products',
                    caseType: 'Compliment - Morrisons',
                    caseCategory: 'Compliment (store) (E)',
                    caseReason: 'Product (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: 'I would like to compliment one of your products',
                    caseType: 'Compliment - Franchise',
                    caseCategory: 'Compliment (E)',
                    caseReason: 'Compliment about a Product (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: 'I would like to compliment one of your products',
                    caseType: 'Compliment - Morrisons Daily',
                    caseCategory: 'Compliment (E)',
                    caseReason: 'Compliment about a Product (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'In Store Experience',
      salesForceType: CATEGORY,
      text: 'In Store Experience',
      searchCategory: 'Stores',
      searchSubCategory: 'Staff and Services',
      nodes: [
        {
          value: 'Service from our Staff in Store',
          salesForceType: SUB_CATEGORY,
          text: 'Service from our Staff in Store',
          nodes: [
            {
              value:
                'I would like to give feedback about the service I have recently received',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like to give feedback about the service I have recently received',
              form: {
                name: 'enquiry-with-store-and-date',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to give feedback about the service I have recently received',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Customer Service ( Stores )',
                    caseReason: 'Service ( Stores )',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like to give feedback about the service I have recently received',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Unhelpful/Rudeness/Attitude of Colleague',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like to give feedback about the service I have recently received',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Unhelpful/Rudeness/Attitude of Colleague',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
        {
          value: 'Shopping in our Stores',
          salesForceType: SUB_CATEGORY,
          text: 'Shopping in our Stores',
          nodes: [
            {
              value:
                'I would like to give feedback about my experience in store',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like to give feedback about my experience in store',
              form: {
                name: 'enquiry-with-store-and-date',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to give feedback about my experience in store',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Shopping Experience',
                    caseReason: 'Experience',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like to give feedback about my experience in store',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Shopping Experience',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like to give feedback about my experience in store',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Shopping Experience',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I need to report damage to my personally property which has happened in one of your stores',
              salesForceType: MINOR_CATEGORY,
              text:
                'I need to report damage to my personally property which has happened in one of your stores',
              form: {
                name: 'incident-damage-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],

                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I need to report damage to my personally property which has happened in one of your stores',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Shopping Experience',
                    caseReason:
                      'Injury / Accident / Damage to personal property',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I need to report damage to my personally property which has happened in one of your stores',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Shopping Experience',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I need to report damage to my personally property which has happened in one of your stores',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Shopping Experience',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I need to report an injury which has happened in one of your stores',
              salesForceType: MINOR_CATEGORY,
              text:
                'I need to report an injury which has happened in one of your stores',
              form: {
                name: 'incident-damage-form',
                fields: [...genericFormsValues(), ...genericFormsDefaults()],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I need to report an injury which has happened in one of your stores',
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Shopping Experience',
                    caseReason:
                      'Injury / Accident / Damage to personal property',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I need to report an injury which has happened in one of your stores',
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Shopping Experience',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I need to report an injury which has happened in one of your stores',
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Shopping Experience',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            // {
            //   value:
            //     'I was refused / Challenged sale on an age restricted product in store',
            //   salesForceType: MINOR_CATEGORY,
            //   text:
            //     'I was refused / Challenged sale on an age restricted product in store',
            //   form: {
            //     name: 'enquiry-with-store-and-date',
            //     fields: [...genericFormsValues(), ...genericFormsDefaults()],
            //     areaValues: [
            //       {
            //         id: '0',
            //         area: 'Morrisons',
            //         subject:
            //           'I was refused / Challenged sale on an age restricted product in store',
            //         caseType: 'Enquiry - Morrisons',
            //         caseCategory: 'Policies/Topical Issues (E)',
            //         caseReason: 'Policy (E)',
            //         detailedReason: '',
            //         recordType: recordTypeCustomer.value,
            //       },
            //       {
            //         id: '1',
            //         area: 'Franchise',
            //         subject:
            //           'I was refused / Challenged sale on an age restricted product in store',
            //         caseType: 'Enquiry - Franchise',
            //         caseCategory: 'Feedback (E)',
            //         caseReason: 'Feedback (E)',
            //         detailedReason: '',
            //         recordType: recordTypeFranchise.value,
            //       },
            //       {
            //         id: '2',
            //         area: 'Morrisons Daily',
            //         subject:
            //           'I was refused / Challenged sale on an age restricted product in store',
            //         caseType: 'Enquiry - Morrisons Daily',
            //         caseCategory: 'Feedback (E)',
            //         caseReason: 'Feedback (E)',
            //         detailedReason: '',
            //         recordType: recordTypeFranchise.value,
            //       },
            //     ],
            //   },
            // },
          ],
        },

        {
          value: 'report-a-trolley-lost-or-Stolen',
          salesForceType: SUB_CATEGORY,
          text: 'Report a trolley lost or Stolen',
          nodes: [
            {
              value: 'I would like to report a trolley lost or abandoned',
              salesForceType: MINOR_CATEGORY,
              text: 'I would like to report a trolley lost or abandoned',
              form: {
                name: 'trolleywise-form',
                fields: [],
              },
            },
          ],
        },
      ],
    },
    {
      value: 'Morrisons Daily',
      salesForceType: CATEGORY,
      text: 'Morrisons Daily',
      searchCategory: 'Morrisons Daily',
      searchSubCategory: 'Morrisons Daily',
      nodes: [
        {
          value: 'Morrisons Daily',
          salesForceType: SUB_CATEGORY,
          text: 'General Enquiry',
          nodes: [
            {
              value: "I've been over charged in a Morrisons Daily",
              salesForceType: MINOR_CATEGORY,
              text: "I've been over charged in a Morrisons Daily",
              form: {
                name: 'enquiry-with-barcode-receipt-morrisons-daily',
                fields: [
                  ...genericFormsValues(),
                  ...genericFormsMorrisonsDaily(),
                ],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject: "I've been over charged in a Morrisons Daily",
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Pricing & Promotions',
                    caseReason:
                      'Pricing ( Standard Promotion not More Card Promotion )',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject: "I've been over charged in a Morrisons Daily",
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Pricing',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject: "I've been over charged in a Morrisons Daily",
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Pricing',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                'I would like to compliment a member of Morrisons Daily staff',
              salesForceType: MINOR_CATEGORY,
              text:
                'I would like to compliment a member of Morrisons Daily staff',
              form: {
                name: 'enquiry-with-date-morrisons-daily',
                fields: [
                  ...genericFormsValues(),
                  ...genericFormsMorrisonsDaily(),
                ],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'I would like to compliment a member of Morrisons Daily staff',
                    caseType: 'Compliment - Morrisons',
                    caseCategory: 'Compliment (store) (E)',
                    caseReason: 'Service (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'I would like to compliment a member of Morrisons Daily staff',
                    caseType: 'Compliment - Franchise',
                    caseCategory: 'Compliment (E)',
                    caseReason: 'Compliment about Colleague Service (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'I would like to compliment a member of Morrisons Daily staff',
                    caseType: 'Compliment - Morrisons Daily',
                    caseCategory: 'Compliment (E)',
                    caseReason: 'Compliment about Colleague Service (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value:
                "I'm not happy with service received in a Morrisons Daily store",
              salesForceType: MINOR_CATEGORY,
              text:
                "I'm not happy with service received in a Morrisons Daily store",
              form: {
                name: 'enquiry-with-date-morrisons-daily',
                fields: [
                  ...genericFormsValues(),
                  ...genericFormsMorrisonsDaily(),
                ],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      "I'm not happy with service received in a Morrisons Daily store",
                    caseType: 'Complaint - Morrisons',
                    caseCategory: 'Customer Service ( Stores )',
                    caseReason: 'Service ( Stores )',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      "I'm not happy with service received in a Morrisons Daily store",
                    caseType: 'Complaint - Franchise',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Unhelpful/Rudeness/Attitude of Colleague',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      "I'm not happy with service received in a Morrisons Daily store",
                    caseType: 'Complaint - Morrisons Daily',
                    caseCategory: 'Colleague & Service',
                    caseReason: 'Unhelpful/Rudeness/Attitude of Colleague',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'How do I get an in-store refund for Morrisons Daily?',
              salesForceType: MINOR_CATEGORY,
              text: 'How do I get an in-store refund for Morrisons Daily?',
              form: {
                name: 'product-complaint-morrisons-daily',
                fields: [
                  ...genericFormsValues(),
                  ...genericFormsMorrisonsDaily(),
                ],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'How do I get an in-store refund for Morrisons Daily?',
                    caseType: 'Enquiry - Morrisons',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability/ Do we stock (E)',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'How do I get an in-store refund for Morrisons Daily?',
                    caseType: 'Enquiry - Franchise',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'How do I get an in-store refund for Morrisons Daily?',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Product (E)',
                    caseReason: 'Availability Query (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
            {
              value: 'Where can I get help understanding my newspaper invoice?',
              salesForceType: MINOR_CATEGORY,
              text: 'Where can I get help understanding my newspaper invoice?',
              form: {
                name: 'enquiry-with-morrisons-daily',
                fields: [
                  ...genericFormsValues(),
                  ...genericFormsMorrisonsDaily(),
                ],
                areaValues: [
                  {
                    id: '0',
                    area: 'Morrisons',
                    subject:
                      'Where can I get help understanding my newspaper invoice?',
                    caseType: '',
                    caseCategory: '',
                    caseReason: '',
                    detailedReason: '',
                    recordType: recordTypeCustomer.value,
                  },
                  {
                    id: '1',
                    area: 'Franchise',
                    subject:
                      'Where can I get help understanding my newspaper invoice?',
                    caseType: '',
                    caseCategory: '',
                    caseReason: '',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                  {
                    id: '2',
                    area: 'Morrisons Daily',
                    subject:
                      'Where can I get help understanding my newspaper invoice?',
                    caseType: 'Enquiry - Morrisons Daily',
                    caseCategory: 'Home News Delivery (E)',
                    caseReason: 'Invoice Request (E)',
                    detailedReason: '',
                    recordType: recordTypeFranchise.value,
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ],
}

const { services: SERVICES, steps: STEPS } = data

module.exports = {
  businessAreaFieldIds,
  genericFormsValues,
  SERVICES,
  STEPS,
}
